import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsQualityControls: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROLS,
	},
	getReportsQualityControl: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL,
	},
  getReportsQualityControlPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL_PREVIEW,
	},
}